import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class StepAuthGuardGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    const authToken = sessionStorage.getItem('authToken');
    if (authToken) {
      return true;
    }

    return this.router.createUrlTree(['/auth']);
  }
}
